import { DashboardTabTable } from "../DashboardTabTable";
import { useDashboardProjectsTab } from "./useDashboardProjectsTab";

const DashboardProjectsTab = (): JSX.Element => {
  const { columns, isLoading, onChange, onViewMore } = useDashboardProjectsTab();

  return (
    <DashboardTabTable
      title="Projects"
      columns={columns}
      isLoading={isLoading}
      noDataMessage="No projects to display"
      onChange={onChange}
      onViewMore={onViewMore}
    />
  );
};

export default DashboardProjectsTab;
